if settings.include_fonts
    each decl in declarations 
        if decl.type == 'font'
            | #include "!{decl.data.value}.h"
            |
    |
    |
each decl in declarations 
    if decl.type == 'bitmap'
        | static const unsigned char PROGMEM !{decl.data.name}[] = {!{decl.data.value}};
        |
        |
if settings.declare_vars
    each decl in declarations 
        if decl.type == 'var'
            if decl.data.type === 0
                | const char* !{decl.data.name} = "!{decl.data.value}";
                |
            else
                | int !{decl.data.name} = !{decl.data.value};
                |
    |
    |
if settings.wrap
    | void draw(void) {
    |
- var textColor = defaultColor;
- var textSize = '1'
- var textWrap = true
- var pad = settings.wrap ? '    ' : ''
- var font = 'adafruit'
- var stringLayersNumber = 0
|
|
each layer in layers 
    if settings.comments
        | !{pad}// !{layer.name}
        |
    case layer.type
        when 'dot' 
            - // deprecated
            | @!{layer.uid};!{pad}tft.drawPixel(!{layer.position[0]}, !{layer.position[1]}, !{layer.color});
        when 'line'
            | @!{layer.uid};!{pad}tft.drawLine(!{layer.x1}, !{layer.y1}, !{layer.x2}, !{layer.y2}, !{layer.color});
        when 'rect'
            - var func = (layer.fill ? 'fill' : 'draw') + (layer.radius? 'Round' : '') + 'Rect'
            | @!{layer.uid};!{pad}tft.!{func}(!{layer.x}, !{layer.y}, !{layer.w}, !{layer.h}!{layer.radius? `, ${layer.radius}`: ''}, !{layer.color});
        when 'circle'
            - var func = layer.fill ? 'fillCircle' : 'drawCircle'
            | @!{layer.uid};!{pad}tft.!{func}(!{layer.x}, !{layer.y}, !{layer.radius}, !{layer.color});
        when 'string'
            if stringLayersNumber === 0
                - textColor = layer.color
                | !{pad}tft.setTextColor(!{layer.color});
                |
                - stringLayersNumber++
            else if layer.color != textColor
                - textColor = layer.color
                | !{pad}tft.setTextColor(!{layer.color});
                |
            if layer.scaleFactor != textSize
                - textSize = layer.scaleFactor
                | !{pad}tft.setTextSize(!{layer.fontSize});
                |
            if layer.wrap != textWrap
                - textWrap = layer.wrap
                | !{pad}tft.setTextWrap(false);
                |
            if layer.font != font 
                - font = layer.font
                if font == 'adafruit'
                    | !{pad}tft.setFont();
                    |
                else
                    | !{pad}tft.setFont(&!{layer.font});
                    |
            | !{pad}tft.setCursor(!{layer.x}, !{layer.y});
            |
            if layer.isTextVariable
                | @!{layer.uid};!{pad}tft.print(!{layer.text});
            else
                | @!{layer.uid};!{pad}tft.print("!{layer.text}");
        when 'paint'
        when 'icon'
            | @!{layer.uid};!{pad}tft.drawBitmap(!{layer.x}, !{layer.y}, !{layer.imageName}, !{layer.w}, !{layer.h}, !{layer.color});
        default 
            |
            | // Unknown layer type !{layer.type}
            |
    |
    |
    |
|
if settings.wrap
    | }
    |